import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import OrderSheetLayout from '../common/OrderSheetLayout';
import GiftRow from './components/GiftRow';
import useOrderGift from './hooks/useOrderGift';

declare module '@stackflow/config' {
    interface Register {
        OrderGiftBottomSheet: {};
    }
}

/** 결제에 사용할 선물(교환권·금액권) 선택 */
const OrderGiftBottomSheet: ActivityComponentType<'OrderGiftBottomSheet'> = () => {
    const { t } = useTranslation('order');
    const {
        gifts, selectedGiftIds, draftGiftAmount, alreadyBalanceSelected,
        toggleGift, handleApply, handleClose,
    } = useOrderGift();

    return (
        <BottomSheet>
            <OrderSheetLayout title={t('giftSheet.title')}
                isEmpty={gifts?.length === 0}
                emptyText={t('giftSheet.empty')}
                closeLabel={t('giftSheet.close')}
                onClose={handleClose}
                applyLabel={t('giftSheet.apply')}
                onApply={handleApply}>
                {gifts?.map((gift) => (
                    <GiftRow key={gift.id}
                        gift={gift}
                        isSelected={selectedGiftIds.includes(gift.id)}
                        draftGiftAmount={draftGiftAmount}
                        alreadyBalanceSelected={alreadyBalanceSelected}
                        onToggle={() => toggleGift(gift.id)} />
                ))}
            </OrderSheetLayout>
        </BottomSheet>
    );
};

export default OrderGiftBottomSheet;
